import {
  IMAGE_DATA_CLEAR,
  IMAGE_DATA_SET_BACK,
  IMAGE_DATA_SET_FRONT,
  IMAGE_TYPE_FRONT,
} from '../constants';

const imageDataSetFront = value => ({
  type: IMAGE_DATA_SET_FRONT,
  payload: { value },
});

const imageDataSetBack = value => ({
  type: IMAGE_DATA_SET_BACK,
  payload: { value },
});

const imageDataSet = (value, type) =>
  type === IMAGE_TYPE_FRONT ? imageDataSetFront(value) : imageDataSetBack(value);

const imageDataClear = () => ({
  type: IMAGE_DATA_CLEAR,
});

export { imageDataClear, imageDataSet, imageDataSetBack, imageDataSetFront };
